import { CommonConstants, VerificationTypes } from '@/config/constant';

export default {
  token: (state) => state.token,
  biometricToken: (state) => state.biometricToken,
  infor: (state) => state.infor,
  isUsePoint: (state) => state.infor?.point !== null,
  point: (state) => state.infor?.point,
  hasPasscode: (state) => state.infor.hasPasscode,
  isAgreed: (state) => state.infor.isAgreed,
  authenticationToken: (state) => state.authenticationToken,
  maximumAmount: (state) => state.maximumAmount,
  isVerify: (state) => !!state.infor?.isVerify,
  dateLinked: (state) => state.infor?.dateLinked,
  smsTimeAt: (state) => state.infor?.smsTimeAt,
  mobilephone: (state) => state.infor?.mobilephone,
  isBlockedSms: (state) => state.infor?.isBlockedSms,
  isBankFlag: (state) => !!state.infor?.bankFlag,
  smsFlag: (state) => !!state.infor?.smsFlag,
  isCiviliosIdentity: (state) => state.infor?.methodIdentity === CommonConstants.civilios,
  isSettingVerify: (state, getters, rootState, rootGetters) => {
    return (rootGetters['event/childEventInfo']?.settingVerify === VerificationTypes.type.identity.value && !getters.isVerify) ||
      (rootGetters['event/childEventInfo']?.settingVerify === VerificationTypes.type.sms.value && !getters.smsFlag) ||
      (rootGetters['event/childEventInfo']?.settingVerify === VerificationTypes.type.both.value && (!getters.smsFlag || !getters.isVerify));
  },
  isCustomerTesting: (state) => !!state.infor?.isCustomerTesting,
};
